import * as GraphQLQueryAPI from "../../../../docs/api/graphql/query.mdx";
import * as GraphQLMutationAPI from "../../../../docs/api/graphql/query.mdx";
import * as GraphQLOperationAPI from "../../../../docs/api/graphql/query.mdx";
import * as GraphQLLinkAPI from "../../../../docs/api/graphql/link.mdx";
import * as React from 'react';
export default {
  GraphQLQueryAPI,
  GraphQLMutationAPI,
  GraphQLOperationAPI,
  GraphQLLinkAPI,
  React
};